import { RefreshCw } from "lucide-react";
import classnames from "classnames";
import { formatDateTime } from "@src/utility/helpers/date";

// Title strip shared by both payment-model boards — only the copy differs, the
// freshness pill and the cache-busting refresh are the same on either side.
const DashboardHeader = ({ title, subtitle, generatedAt, refreshing, refresh }) => (
  <div className="flex items-end justify-between">
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      <p className="text-sm text-muted">{subtitle}</p>
    </div>
    <div className="hidden items-center gap-2 md:flex">
      <div className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs text-muted">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-success/60" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-success" />
        </span>
        Updated {generatedAt ? formatDateTime(generatedAt) : "\u2014"}
      </div>
      <button
        type="button"
        onClick={refresh}
        disabled={refreshing}
        className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 transition hover:bg-gray-50 disabled:opacity-60"
      >
        <RefreshCw
          className={classnames("h-3.5 w-3.5", { "animate-spin": refreshing })}
        />
        {refreshing ? "Refreshing\u2026" : "Refresh"}
      </button>
    </div>
  </div>
);

export default DashboardHeader;
